export default __webpack_public_path__ + "static/media/selfIcon.ce7057dd.png";